import { useCallback } from 'react';
import SingleEntityModal from 'components/SingleEntityModal';
import { useToggle } from 'react-use';
import { fetchSingleEntity } from 'thunk';
import { useAppDispatch } from 'redux/hooks';

const useSingleEntityModal = () => {
  const [isOpen, toggle] = useToggle(false);
  const dispatch = useAppDispatch();

  const open = useCallback(
    ({ entityId }: { entityId: number }) => {
      dispatch(
        fetchSingleEntity({
          entityId,
        }),
      );
      toggle();
    },
    [dispatch, toggle],
  );

  const Modal = () => (isOpen ? <SingleEntityModal onClose={toggle} open /> : <></>);

  return {
    SingleEntityModal: Modal,
    openModal: open,
  };
};

export default useSingleEntityModal;
